module.exports = __webpack_public_path__ + "dc5d2598558ed38cfba8e33deccfb3ff.png";